// Standard CRUD actions
export const redux_getAllAdminUsers = (payload: any) => ({ 
  type: 'GET_ALL_ADMIN_USERS', 
  payload 
});

export const redux_getAllUsers = (payload: any) => ({ 
  type: 'GET_ALL_USERS', 
  payload 
});

export const redux_getAdminUser = (payload: any) => ({ 
  type: 'GET_ADMIN_USER', 
  payload 
});

export const redux_updateAdminUser = (payload: any) => ({ 
  type: 'UPDATE_ADMIN_USER', 
  payload 
});

export const redux_createAdminUser = (payload: any) => ({ 
  type: 'CREATE_ADMIN_USER', 
  payload 
});

export const redux_deleteAdminUser = (payload: any) => ({ 
  type: 'DELETE_ADMIN_USER', 
  payload 
});

export const redux_updateAdminRole = (payload: any) => ({ 
  type: 'UPDATE_ADMIN_ROLE', 
  payload 
});

// Loading and error states
export const redux_adminManagementActionStarts = () => ({ 
  type: 'ADMIN_MANAGEMENT_ACTION_STARTS' 
});

export const redux_adminManagementActionErrors = (payload: any) => ({ 
  type: 'ADMIN_MANAGEMENT_ACTION_ERRORS', 
  payload 
});

export const redux_resetAdminManagementErrors = () => ({ 
  type: 'RESET_ADMIN_MANAGEMENT_ERRORS' 
}); 